import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { combineReducers, createFeature, provideState } from '@ngrx/store';
import { AuthBusinessProfilesEffects } from '../effects/business-profiles.effects';
import { TagCategoriesEffects } from '../effects/tag-categories.effects';
import { tagCategoriesFeature, TagCategoryState } from './tag-categories.reducer';

export interface ApplicationState {
  [tagCategoriesFeature.name]: TagCategoryState;
}

export const applicationFeatures = createFeature<string, ApplicationState>({
  name: 'iot-platform-application',
  reducer: combineReducers({
    [tagCategoriesFeature.name]: tagCategoriesFeature.reducer
  })
});

export function provideIotPlatformApplicationState(): EnvironmentProviders[] {
  return [provideState(applicationFeatures.name, applicationFeatures.reducer), provideEffects(TagCategoriesEffects)];
}

export function provideIotPlatformBusinessProfileWhenReadRuleOnDeviceConfiguratorConceptState(): EnvironmentProviders[] {
  return [provideEffects(AuthBusinessProfilesEffects)];
}
